export default "__VITE_ASSET__BhPMKBJK__"